import { ListTableCard } from "@/accounts-payable/common";
import { useGetVendors } from "@/accounts-payable/query";
import { vendorCol, serviceTitanCol, aliasesCol } from "./cols";

const columns = [vendorCol, serviceTitanCol, aliasesCol];

export const ApVendorsTab = ({
  businessId,
  selectedId = null,
  onSelect,
}: {
  businessId: string | null;
  selectedId?: string | null;
  onSelect: (id: string) => void;
}) => {
  const query = useGetVendors(businessId);

  return (
    <ListTableCard
      query={query}
      columns={columns}
      selectedId={selectedId}
      onSelect={onSelect}
      empty={{
        title: "No vendors yet",
        body: "Vendors you receive invoices from will show up here.",
      }}
      error={{
        title: "Couldn’t load vendors",
        body: "Please try again in a moment.",
      }}
    />
  );
};
